import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardTitle, ListGroup, ListGroupItem } from 'react-bootstrap';
import WareHouseSales from './WareHouseSales';
import InvoiceSummaryHistory from './InvoiceSummaryHistory';
import WareHouse from './WareHouse';

const SingleWarehouse = (props) => {
  const { warehouseId: paramId } = useParams();
  const warehouseId = paramId || 'Foulger'; // fallback for dashboard

  return (
    <Card>
      <Card.Header>
        <CardTitle>{warehouseId}</CardTitle>
      </Card.Header>
      <Card.Body>
        <WareHouse {...props} warehouseId={warehouseId} single={true} />
        <InvoiceSummaryHistory warehouse={warehouseId} />
        <WareHouseSales title={warehouseId} contactName={warehouseId} months="3" />

        <ListGroup>
          <ListGroupItem as={Link} to={`/view/${warehouseId}/tran`}>
            View Warehouse Transactions
          </ListGroupItem>
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default SingleWarehouse;
